import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BookDemoService } from '../dialogs/book-demo-dialog/book-demo.service';

@Component({
  selector: 'app-talent-search-v2',
  templateUrl: './talent-search-v2.component.html',
  styleUrls: ['./talent-search-v2.component.scss'],
})
export class TalentSearchV2Component implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private bookDemo: BookDemoService,
    private meta: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {
    this.setTalentSearchMetaImage();
    if (!isPlatformBrowser(this.platformId)) return;
    const param = this.route.snapshot.queryParamMap.get('book-demo');
    if (param !== null && param !== 'false' && param !== '0') {
      this.bookDemo.open();
    }
  }

  private setTalentSearchMetaImage(): void {
    const url = 'https://uptal.com/assets/images/talent-search-meta-image.jpg';
    this.meta.updateTag({ property: 'og:url', content: 'https://uptal.com/talent-search' });
    this.meta.updateTag({ property: 'og:image', content: url });
    this.meta.updateTag({ property: 'og:image:secure', content: url });
    this.meta.updateTag({ property: 'og:image:secure_url', content: url });
    this.meta.updateTag({ property: 'og:image:width', content: '1200' });
    this.meta.updateTag({ property: 'og:image:height', content: '633' });
    this.meta.updateTag({
      property: 'og:image:alt',
      content: 'Uptal Talent Search — 1M+ Verified Saudi Candidates',
    });
    this.meta.updateTag({ name: 'twitter:image', content: url });
    this.meta.updateTag({
      name: 'twitter:image:alt',
      content: 'Uptal Talent Search — 1M+ Verified Saudi Candidates',
    });
  }
}
